import {useHistory} from 'react-router-dom';
import {MenuItem} from '@material-ui/core';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {CreditNote} from '../../../types/CreditNote/CreditNote';

const CreditNoteDetailsAction = React.forwardRef<HTMLLIElement, {
  creditNote: CreditNote;
  setMenuAnchor: (value: ((prevState: Element | undefined) => Element | undefined) | Element | undefined) => void;
}>(({
  creditNote,
  setMenuAnchor,
}, ref) => {
  const { t } = useTranslation('creditNotes');

  let history = useHistory();
  return (
    <MenuItem
      ref={ref}
      onClick={() => {
        setMenuAnchor(undefined);
        history.push(`/dashboard/transactions/credit-notes/${creditNote.id}/`);
      }}
    >
      {t('credit note details')}
    </MenuItem>
  );
});

export default CreditNoteDetailsAction;
